export const SET_LIST_FILTER = 'localsettings/setListFilter'
export const CLEAR_ALL_FILTERS = 'localsettings/clearListFilter'
